// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2sQWU","author":"Table_author__3rLSO","authorImage":"Table_authorImage__bYZMv","unreadRow":"Table_unreadRow__RC7K1"};